import React from 'react';
import { connect } from 'react-redux';
import ShortcutButton from '../shortcut-button/ShortcutButton';
import { completeWizard } from './logActivityReducer';

@connect(
    state => ({
        isSaving: state.logActivityWizard.isSaving,
        scheduledMeetingData: state.logActivityWizard.scheduledMeetingData,
    }),
    { completeWizard }
)
export default class CompleteButton extends React.Component {
	onComplete() {
		if(this.props.beforeSave) {
			this.props.beforeSave();
		}

		this.props.completeWizard();
	}
	render() {
		var { isSaving } = this.props;
		var completeIconClassName = isSaving ? "fa fa-spinner fa-spin" : "fa fa-check";

		return (
			<ShortcutButton disabled={isSaving} shortcut="c" growTo={1} type="primary" onClick={this.onComplete.bind(this)}>
			    Complete <i className={completeIconClassName} style={{marginLeft: 10}}></i>
			</ShortcutButton>
		);
	}
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/CompleteButton.js